module.exports = __webpack_public_path__ + "img/combo-home.0a2c1c5a.png";